import React from 'react';
import { Box } from '@mui/material'
import styled from 'styled-components'

export const SigningStatusesViewContainer = styled(Box)`
  position: relative;
  min-height: 500px;
`

